import { matchPath } from 'react-router-dom';

// Routes that render edge-to-edge instead of inside the 1280px reading column.
// Width is a function of the URL, so it is derived here rather than pushed into
// shared state by each view — that let an unmounting view clear the flag for
// the one replacing it.
//
// Patterns are copied verbatim from the <Route path=...> values in root/IRM.tsx
// and matched with the router's own matcher, so trailing slashes, casing and
// segment boundaries behave identically to the routes themselves.
const FULL_WIDTH_PATHS = [
    '/markets/*',
    '/monitor/*',
    '/watchlists',
    '/gates',
    '/screener',
    '/screener_simulation',
    '/trader/:address',
    '/chats',
    '/chats/new',
    '/chat/:conversationId',
];

export const isFullWidthRoute = (pathname: string) =>
    FULL_WIDTH_PATHS.some(p => matchPath(p, pathname) !== null);
